import React from 'react';
import { connect } from 'react-redux';
import { resetPin } from '../../redux/profile/profile.actions';

import Card from 'react-bootstrap/Card';
const ResetPIN = ({ resetPin }) => (
	<div>
		<div className="row">
			<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
				<Card>
					<Card.Body>
						<Card.Title>
							<div className="page-header-left">RESET your PIN</div>
						</Card.Title>
						<div className="merge-account-text">
							If you want to reset the PIN of your STEP account, click on the RESET PIN
							button.
						</div>
						<button aria-label="reset" className="btn-merge" onClick={resetPin}>
							RESET PIN
						</button>
					</Card.Body>
				</Card>
			</div>
		</div>
	</div>
);

const mapDispatchToProps = (dispatch) => {
	return {
		resetPin: () => dispatch(resetPin()),
	};
};

export default connect(null, mapDispatchToProps)(ResetPIN);
